module.exports = __webpack_public_path__ + "img/1.7e97797b.png";